import { render, staticRenderFns } from "./dichiarazioneProduzione.vue?vue&type=template&id=37ade5ac&scoped=true"
import script from "./dichiarazioneProduzione.vue?vue&type=script&lang=js"
export * from "./dichiarazioneProduzione.vue?vue&type=script&lang=js"
import style0 from "./dichiarazioneProduzione.vue?vue&type=style&index=0&id=37ade5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ade5ac",
  null
  
)

export default component.exports